/***************************************************************************************************
 * Polyfills for Safari 11 and older browsers
 * MUST be imported before Angular to ensure compatibility
 */
import 'core-js/stable';
// Explicit polyfill for Array.prototype.flat (ES2019) - not supported in Safari 11
import 'core-js/features/array/flat';
import 'core-js/features/array/flat-map';

import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { env } from '../env';

/***************************************************************************************************
 * Zone JS is required by default for Angular itself.
 */
import 'zone.js/dist/zone'; // Included with Angular CLI.

import * as Sentry from "@sentry/angular";

Sentry.init({
  dsn: "https://4b4c463941d64f72b23f06583d6a8046@sentry.nitsnets.com/120",

  // Adds request headers and IP for users, for more info visit:
  // https://docs.sentry.io/platforms/javascript/guides/angular/configuration/options/#sendDefaultPii
  sendDefaultPii: true,
});

if (env.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule, { preserveWhitespaces: false })
    .catch((err) => console.log(err));
